export const environment = {
  production: false,
  appEnv: 'dev',
  cognito: {
    userPoolId: 'us-east-2_JDUX7dvIV',
    userPoolWebClientId: '1k9fdmijlfm5mir2lqvj6geh9u',
  },
  alimentosBebidasApi: 'https://ta1podjznb.execute-api.us-east-2.amazonaws.com/dev/alimentos-bebidas',
  coreApi: 'https://ta1podjznb.execute-api.us-east-2.amazonaws.com/dev/core',
  operationsApi: 'https://ta1podjznb.execute-api.us-east-2.amazonaws.com/dev/operations',
  sourcingApi: 'https://ta1podjznb.execute-api.us-east-2.amazonaws.com/dev/sourcing',
  salesApi: 'https://ta1podjznb.execute-api.us-east-2.amazonaws.com/dev/sales',
  productApi: 'https://ta1podjznb.execute-api.us-east-2.amazonaws.com/dev/product',
  cognitoDomain: 'https://explorandes.auth.us-east-2.amazoncognito.com',
  isLocal: false,
};
